import { styled } from "styled-components";

import { CrossIcon, SectionTitleUnderlined } from "common/components";
import { UIInput } from "common/components/form/UIInput";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { DimensionLimitWarning } from "domains/createMapDetail/components/keyIssueList/DimensionLimitWarning";
import { DimensionsList } from "domains/createMapDetail/components/keyIssueList/DimensionsList";
import { CreateCustomKeyIssueButton } from "domains/customKeyIssue/components/CreateCustomKeyIssueButton";
import { dimensionSlice } from "domains/dimension/dimension.slice";
import { getCanAccessCreate, getCreateMapCustomKeyIssueAccess } from "entities/permissions/selectors";

type DimensionsListPanelProps = { toggleAddingKeyIssue: () => void; toggleVisibility?: () => void };

export const DimensionsListPanel = ({ toggleAddingKeyIssue, toggleVisibility }: DimensionsListPanelProps) => {
  const dispatch = useDispatch();
  const searchTerm = useSelector((state) => state.dimension.search);
  const canAccessCreate = useSelector(getCanAccessCreate);
  const canCreateCustomKeyIssue = useSelector(getCreateMapCustomKeyIssueAccess);
  const translate = useTranslate();

  const onChange = (value: string) => dispatch(dimensionSlice.actions.setSearch(value));

  const rightElement = (
    <Right>
      <CreateCustomKeyIssueButton onAdd={toggleAddingKeyIssue} showStarIcon={!canCreateCustomKeyIssue} />
      {toggleVisibility && <ClearIcon onClick={toggleVisibility} />}
    </Right>
  );

  return !canAccessCreate ? null : (
    <Container>
      <TopBar>
        <SectionTitleUnderlined rightElement={rightElement}>{translate("app.topic.key_issues")}</SectionTitleUnderlined>
        <UIInput clear={() => onChange("")} onChange={onChange} value={searchTerm ?? ""} />
        <DimensionLimitWarning />
      </TopBar>
      <DimensionsList />
    </Container>
  );
};

const Right = styled.div`
  align-items: center;
  display: flex;
`;

const ClearIcon = styled(CrossIcon)`
  color: ${({ theme }) => theme.colors.textFade};
  cursor: pointer;
  height: 18px;
  margin-left: 0.5rem;
  transition: all 0.3s;
  width: 18px;

  &:hover {
    color: ${({ theme }) => theme.colors.textBright};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 1rem 1rem 0;
`;
